<template>
	<div>
		<section class="content-header mt-2">
			<h1 class="pull-left"><font-awesome-icon icon="chart-pie" /> Visualizations</h1>
			<router-link class="btn btn-success pull-right" :to="{ name: 'visualization.create' }"><font-awesome-icon icon="plus" /></router-link>
		</section>
		<div class="content">
			<error-component
				v-if="exceptions.length > 0"
				v-bind="exceptions[0]">
			</error-component>
			<success-component
				v-if="success.length > 0"
				:message="success">
			</success-component>
			<div v-if="loading">
				<bouncing-component></bouncing-component>
			</div>
			<div v-else>
				<render-index-table :visualizations="visualizations"></render-index-table>

				<b-pagination align="center" size="md"
							:total-rows="pagination.totalRows"
							v-model="pagination.currentPage"
							:limit="pagination.limit"
							:per-page="pagination.limit"
							@change="change">
				</b-pagination>
			</div>

		</div>
	</div>
</template>

<script>
	import RenderIndexTable from './RenderIndexTable.vue';
	import BouncingComponent from '../../components/Bouncing-loader.vue';
	import SuccessComponent from '../../components/Success.vue';
	import ErrorComponent from '../../components/ErrorView.vue';
	import {mapState} from 'vuex';

	export default {
		data() {
			return {
				unwatch: '',
				loading: true
			}
        },
        beforeDestroy() {
            this.$store.commit('visualizations/SET_VISUALIZATIONS', []);
            this.$store.dispatch('clearMessages');
            this.unwatch();
        },
		components: {
			SuccessComponent,
			ErrorComponent,
			BouncingComponent,
			RenderIndexTable
		},
		computed: {
			...mapState('visualizations', {
				visualizations: 'items',
				pagination: 'pagination'
			}),
			...mapState({
				success: 'success',
				exceptions: 'exceptions'
			})
		},
		created() {
			let page = this.$route.query.page;
			if (page) {
				this.update(parseInt(page));
			}
			else {
				this.$store.dispatch('visualizations/fetch').finally(() => {
					this.loading = false;
				});
			}
			this.unwatch = this.$store.watch(
				(state)=>
					this.$store.state.organizationSelected
				,
				(newValue, oldValue)=>{
					this.$store.dispatch('visualizations/setInitialStatus');
					this.$router.push({ name: 'visualization', query: { page: 1 } });
				},
			);
		},
		methods: {
			change(page) {
				this.update(page);
				this.$router.push({ name: 'visualization', query: { page: page } });
			},
			update(page) {
				this.$store.commit('visualizations/SET_CURRENT_PAGE', page);
				this.loading = true;
				this.$store.dispatch('visualizations/fetch').finally(() => {
					this.loading = false;
				});
			}
		},
	}
</script>